import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const ResultComponent = ({ status, title, subTitle, extra }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      p={4}
      bgcolor={status === "success" ? "green.100" : "red.100"}
      borderRadius={4}
      boxShadow={2}
    >
      {status === "success" ? (
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 80 }} />
      ) : (
        <CancelOutlinedIcon sx={{ fontSize: 80, color: "#ba000d" }} />
      )}
      {/* Add other icons or status indicators as needed */}

      <Typography
        variant="h4"
        gutterBottom
        fontFamily={"Tajawal"}
        marginTop={4}
        fontWeight={"bolder"}
      >
        {title}
      </Typography>
      <Typography variant="subtitle1" color="textSecondary" gutterBottom>
        {subTitle}
      </Typography>

      {extra && (
        <Box mt={2}>
          {extra.map((action, index) => (
            <Button
              key={index}
              variant="contained"
              color={action.color}
              sx={{ fontFamily: "Tajawal", fontSize: 16 }}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ResultComponent;
